import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";

export const getSales = async (config?: AxiosRequestConfig) => {
  const params = config?.params;

  if (params?.sort) {
    params.sort = JSON.stringify(params.sort);
  }

  if (params?.filters) {
    params.filters = JSON.stringify(params.filters);
  }

  const { data } = await axiosInstance.get("/sales", config);
  return data;
};

export const importSales = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const { data: response } = await axiosInstance.post(
    "/sales/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response;
};
